var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex",class:_vm.color},[_c('div',{staticClass:"dot",class:_vm.color},[_c('div',{staticClass:"dot-inner",class:_vm.color})]),_vm._v("\n  "+_vm._s(_vm.status)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }